module.exports = __webpack_public_path__ + "static/media/_F14-Passport_js.9e42341d.svg";